import { assignInlineVars } from "@vanilla-extract/dynamic";

import { Text } from "chameleon/lib/components";

import {
  formTitleClass,
  paddingVar,
} from "checkout-experience/components/forms/form-title.css";

interface Props {
  title: string;
  value?: string;
  hasPaddingBottom?: boolean;
}

export const FormTitle = ({ title, hasPaddingBottom = false }: Props) => {
  return (
    <div
      className={formTitleClass}
      style={assignInlineVars({ [paddingVar]: hasPaddingBottom ? "6" : "0" })}
    >
      <Text styleVariant="heading2">{title}</Text>
    </div>
  );
};
